import { render, staticRenderFns } from "./StampCardDetailsPanel.vue?vue&type=template&id=2586fe7d&scoped=true&"
import script from "./StampCardDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./StampCardDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./StampCardDetailsPanel.vue?vue&type=style&index=0&id=2586fe7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586fe7d",
  null
  
)

export default component.exports